import { LanguageService } from '@/services';
import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SpinnerButtonConfig } from '@/ui/spinner-button/spinner-button-config';
import { Group } from 'src/app/models/group';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorService } from 'src/app/services/error/error.service';
import { GroupService } from 'src/app/services/group/group.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
    selector: 'app-join-group',
    templateUrl: './join-group.component.html',
    styleUrls: ['./join-group.component.scss'],
    standalone: false
})
export class JoinGroupComponent implements OnInit {
  allGroups: Group[] = [];
  filteredGroups: Group[] = [];
  currentGroups: Group[] = [];
  selectedGroupId: string;
  selectedGroup: Group;

  pinFormControl = new FormControl<string>('');

  btnConfig: SpinnerButtonConfig = {
    text: `Deelnemen`,
  };

  constructor(
    private groupService: GroupService,
    private userService: UserService,
    private authService: AuthService,
    private errorService: ErrorService,
    private notificationService: NotificationService,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: DialogRef<JoinGroupComponent>
  ) {
    this.btnConfig.text = this.languageService.translateWithCap('general.actions.join');
  }

  ngOnInit(): void {
    this.currentGroups = this.data.currentGroups;
    this.getGroups();
  }

  getGroups() {
    this.groupService.getGroups(false).subscribe({
      next: groups => {
        groups.sort((a, b) => a.name.localeCompare(b.name));
        this.allGroups = groups;
        this.createFilteredList();
      },
      error: e => this.errorService.onError(e),
    });
  }

  createFilteredList() {
    this.filteredGroups = [];
    for (let group of this.allGroups) {
      if (!this.currentGroups.find(x => x.id == group.id)) {
        this.filteredGroups.push(group);
      }
    }
  }

  save() {
    this.btnConfig.loading = true;
    if (this.selectedGroup.pin && this.selectedGroup.pin !== this.pinFormControl.value) {
      this.notificationService.error(this.languageService.translateWithCap('home.join-group-dialog.incorrect-pin'));
      this.btnConfig.loading = false;
      return;
    }
    this.groupService.addStudentsToGroup(this.selectedGroupId, [this.authService.getLoggedInUserId()]).subscribe({
      next: d => {
        this.btnConfig.loading = false;
        this.dialogRef.close();
      },
      error: e => {
        this.errorService.onError(e);
        this.btnConfig.loading = false;
      },
    });
  }

  onGroupChange(event: any) {
    this.selectedGroupId = event.value;
    this.selectedGroup = this.allGroups.find(x => x.id == event.value)!;
  }

  checkButtonDisabledState(): boolean {
    if (!this.selectedGroup) {
      return true;
    }
    if (this.selectedGroup.pin == null) {
      return false;
    }
    if (!this.pinFormControl.value) {
      return true;
    }
    return false;
  }
}
